<template>
  <div class="chart-page">
    <div class="chart-toolbar">
      <div class="toolbar-row">
        <pods-input
          ref="podsInput"
          :globalSync="false"
          @updateData="getData()"
        />
        <div class="toolbar-actions">
          <UtcOffsets />
        </div>
      </div>
      <div class="toolbar-row">
        <span class="filter-label">{{ $t('text.find_data_with_tag') }}</span>
        <el-select
          size="small"
          v-model="tagFilter"
          :placeholder="$t('text.please_select')"
          clearable
          multiple
          style="width: 220px"
        >
          <el-option
            v-for="item in tagOptions"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
        <el-button size="small" type="primary" plain @click="getData()">
          {{ $t('text.find') }}
        </el-button>
        <div class="toolbar-actions">
          <el-input
            v-model="filter"
            size="small"
            prefix-icon="el-icon-search"
            clearable
            style="width: 180px"
            :placeholder="$t('text.notes')"
          />
        </div>
      </div>
    </div>

    <el-table
      border
      ref="table"
      :data="tableData"
      size="small"
      v-loading="loading"
      :max-height="tableHeight"
      class="app-table"
    >
      <el-table-column :label="$t('text.mac_address')" prop="podMac" />
      <el-table-column :label="$t('text.tag_timestamp')" prop="tagDateTime">
        <template slot-scope="scope">
          {{
            moment
              .utc(scope.row.tagDateTime)
              .tz($store.state.pods.selectedUtcOffset)
              .format('DD/MM/YY')
          }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('text.tagged_by')" prop="taggedBy" />
      <el-table-column :label="$t('text.tag')" prop="tag">
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.tag" :key="index">
            {{ item }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('text.notes')" prop="notes" />
      <el-table-column
        :label="$t('text.action') | firstLetterCapitalize"
        fixed="right"
        width="180"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="edit(scope.row)">
            {{ $t('text.view') | firstLetterCapitalize }}
          </el-button>
          <el-button
            size="mini"
            type="danger"
            plain
            @click="deleteRow(scope.row)"
          >
            {{ $t('text.delete') | firstLetterCapitalize }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <ViewTaggedData ref="viewTaggedData" />
  </div>
</template>

<script>
import { tagOptions } from '../../const.js'
import PodsInput from '@/components/PodsInput'
import UtcOffsets from '@/components/UtcOffsets'
import ViewTaggedData from '@/components/pods/findData/ViewTaggedData'
import CommonApiService from '@/services/CommonApiService.js'
import moment from 'moment'
import swal from 'sweetalert'

export default {
  data() {
    return {
      moment,
      loading: false,
      tableData: [],
      tagOptions: tagOptions,
      tagFilter: '',
      filter: '',
      timer: '',
      tableHeight: 0
    }
  },
  components: {
    PodsInput,
    UtcOffsets,
    ViewTaggedData
  },
  mounted() {
    this.getData()
    this.$nextTick(() => {
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 150
      const self = this
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 150
      }
    })
  },
  watch: {
    filter() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getData() {
      this.loading = true
      CommonApiService.GetDataTags(
        this.$refs.podsInput.pod ? this.$refs.podsInput.pod.podId : '',
        JSON.parse(JSON.stringify(this.tagFilter)).join(','),
        this.filter
      )
        .then(response => {
          this.loading = false
          this.tableData = response.data.map(item => ({
            ...item,
            tag: item.tag.split(',')
          }))
        })
        .catch(() => {
          this.loading = false
          swal({ icon: 'error', timer: 2000, title: this.$t('text.failed') })
        })
    },
    edit(row) {
      this.$refs.viewTaggedData.id = row.id
      this.$refs.viewTaggedData.openDialog()
    },
    deleteRow(row) {
      this.$confirm(
        'Please keep in mind that deleting tagged data is permanent',
        this.$t('text.you_able_to_delete_data') + ' this tag data',
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'delete-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: false,
          closeOnClickModal: false
        }
      )
        .then(() => this.handleDelete(row))
        .catch(() => {})
    },
    handleDelete(row) {
      CommonApiService.DeleteDataTagById(row.id)
        .then(() => this.getData())
        .catch(() => {
          swal({ icon: 'error', timer: 2000, title: this.$t('text.failed') })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-label {
  font-size: 13px;
  color: var(--text2, #6b7280);
  white-space: nowrap;
}
</style>
